import styled from 'styled-components';

export const CollapseContent = styled.div<{
  fadeDuration: string;
  collapseDuration: string;
}>(({ fadeDuration, collapseDuration }) => ({
  transformOrigin: 'bottom',
  transition: `height ${collapseDuration} ease-in-out, opacity ${fadeDuration} ease`,
}));
